import { render, staticRenderFns } from "./TractCertificationBases.vue?vue&type=template&id=1bf222a0&scoped=true&"
import script from "./TractCertificationBases.vue?vue&type=script&lang=js&"
export * from "./TractCertificationBases.vue?vue&type=script&lang=js&"
import style0 from "./TractCertificationBases.vue?vue&type=style&index=0&id=1bf222a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf222a0",
  null
  
)

export default component.exports